import { AccordionEnhancedItemProps } from '@ahc-digital/component-library';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { getDroplink } from '@/shared/param-utils';
import { useConditionalRendering } from '@/shared/useConditionalRendering';
import { ACCORDION_ENHANCED_ITEM_CONTENT_CONTAINER } from '@/shared/static';
import { C36AccordionEnhancedItemProps } from './C36AccordionEnhancedItem.types';

export function CreateC36AccordionEnhancedModel(props?: C36AccordionEnhancedItemProps) {
  type t = AccordionEnhancedItemProps;
  const { fields, params, rendering } = props || {};
  const { renderText, renderRichText, renderImage } = useConditionalRendering();
  const contentPlaceholderName = ACCORDION_ENHANCED_ITEM_CONTENT_CONTAINER.replace(
    '{*}',
    params?.DynamicPlaceholderId || ''
  );
  return {
    alwaysVisibleText: renderRichText(fields?.AlwaysVisibleText),
    children: rendering && <Placeholder name={contentPlaceholderName} rendering={rendering} />,
    headline: renderText(fields?.Headline),
    headlineIcon: getDroplink<t['headlineIcon']>(params?.HeadlineIcon),
    headlineImage: renderImage(fields?.HeadlineImage),
    headlineTag: getDroplink(params?.HeadlineTag, 'h3'),
  };
}
